import { OptionItem } from "@transfr-inc/dashboard-components/forms";

export class UserOptionItem extends OptionItem {
  /**
   * @param {object} user
   * @param {object} [options]
   * @param {boolean} [options.markArchived] - Suffixes "(Archived)" on an
   *   archived user's label. `Select` searches options by their plain-string
   *   `text`, so the marker rides in that text; a JSX badge would render but
   *   make the option unsearchable.
   */
  constructor(user, { markArchived = false } = {}) {
    const { userId, firstName, lastName, isArchived } = user;
    const name = `${lastName}, ${firstName}`;
    super({
      id: userId,
      text: markArchived && isArchived ? `${name} (Archived)` : name,
      data: user,
    });
  }
}
